import { SimpleMenu } from '../../../../common/types/components';
import * as RolesConstants from '../../../constants/RolesConstants';

export const EDIT: string = 'EDIT';
export const PREVIEW: string = 'PREVIEW';
export const ATTACHMENT: string = 'ATTACHMENT';
export const AMORTIZATION: string = 'AMORTIZATION';
export const CHANGE_STATUS_LOG: string = 'CHANGE_STATUS_LOG';
export const CHAT: string = 'CHAT';
export const CHECK: string = 'CHECK';
export const SEND_TO_PIPEFY: string = 'send-to-pipefy';

export const LOAN_APPLICATION: string = 'loan-application';
export const LOAN_APPLICATION_MOTORFY: string = 'loan-application-motorfy';
export const LOAN_APPLICATION_CC = 'loan-application-motorfy-from-log';
export const QUOTE: string = 'quote';
export const INSURANCE: string = 'insurance';
export const GPS: string = 'gps';
export const POINT_OF_SALE: string = 'point-of-sale';
export const BUREAU: string = 'bureau';
export const BANK_ACCOUNT: string = 'bank-account';
export const PRE_AUTHORIZATION: string = 'pre-authorization';
export const OPENING_COMMISSION: string = 'opening-commission';
export const DEPOSIT_LETTER: string = 'deposit-letter';
export const COMMISSION_BANK_ACCOUNT: string = 'commission-bank-account';
export const CLOSING_ADVISOR: string = 'closing-advisor';
export const RECORDS: string = 'records';
export const GIFT_CARDS: string = 'gift-cards';
export const VALIDATION_ID: string = 'validation-id';
export const CREDITO_REAL: string = 'credito-real';
export const SALESFORCE: string = 'salesforce';
export const FINISH: string = 'finish';
export const CLOSING_BANK: string = 'closing-bank';
export const APPROVAL_CONDITIONS: string = 'approval-conditions';
export const EMAIL_CONTINUE_LOAN_APPLICATION: string = `continue-${LOAN_APPLICATION}`;
export const SEND_LOAN_APPLICATION_BANK: string = `send-${LOAN_APPLICATION}-to-bank`;
export const CLOSING_ADVISOR_LOAN_APPLICATION: string = `${CLOSING_ADVISOR}-${LOAN_APPLICATION}`;
export const RECORDS_LOAN_APPLICATION: string = `${RECORDS}-${LOAN_APPLICATION}`;
export const GIFT_CARDS_LOAN_APPLICATION: string = `${GIFT_CARDS}-${LOAN_APPLICATION}`;
export const VALIDATION_ID_LOAN_APPLICATION: string = `${VALIDATION_ID}-${LOAN_APPLICATION}`;
export const CREDITO_REAL_LOAN_APPLICATION: string = `${CREDITO_REAL}-${LOAN_APPLICATION}`;
export const SALESFORCE_LOAN_APPLICATION: string = `${SALESFORCE}-${LOAN_APPLICATION}`;
export const FINISH_LOAN_APPLICATION: string = `${FINISH}-${LOAN_APPLICATION}`;
export const CLOSING_BANK_LOAN_APPLICATION: string = `${CLOSING_BANK}-${LOAN_APPLICATION}`;
export const APPROVAL_CONDITIONS_LOAN_APPLICATION: string = `${APPROVAL_CONDITIONS}-${LOAN_APPLICATION}`;
export const SEND_TO_PIPEFY_LOAN_APPLICATION: string = `${SEND_TO_PIPEFY}-${LOAN_APPLICATION}`;

export const EDIT_PREFIX_CHILDREN: string = `${EDIT.toLocaleLowerCase()}`;
export const PREVIEW_PREFIX_CHILDREN: string = `${PREVIEW.toLocaleLowerCase()}`;
export const CHECK_PREFIX_CHILDREN: string = `${CHECK.toLocaleLowerCase()}`;

export const EDIT_APPLICANT: string = `${EDIT_PREFIX_CHILDREN}-applicant`;
export const EDIT_HOME: string = `${EDIT_PREFIX_CHILDREN}-home`;
export const EDIT_BUREAU: string = `${EDIT_PREFIX_CHILDREN}-${BUREAU}`;
export const EDIT_WORK: string = `${EDIT_PREFIX_CHILDREN}-work`;
export const EDIT_CURRENT_WORK: string = `${EDIT_PREFIX_CHILDREN}-current-work`;
export const EDIT_LAST_WORK: string = `${EDIT_PREFIX_CHILDREN}-last-work`;
export const EDIT_REFERENCE: string = `${EDIT_PREFIX_CHILDREN}-reference`;
export const EDIT_VEHICLE: string = `${EDIT_PREFIX_CHILDREN}-vehicle`;
export const EDIT_CREDIT_CONDITION: string = `${EDIT_PREFIX_CHILDREN}-credit-condition`;
export const EDIT_PERSONAL_INTERVIEW: string = `${EDIT_PREFIX_CHILDREN}-personal-interview`;
export const EDIT_INSURANCE: string = `${EDIT_PREFIX_CHILDREN}-${INSURANCE}`;
export const EDIT_GPS: string = `${EDIT_PREFIX_CHILDREN}-${GPS}`;
export const EDIT_GUARANTEE_MECHANICAL: string = `${EDIT_PREFIX_CHILDREN}-guarantee-mechanical`;
export const EDIT_POINT_OF_SALE: string = `${EDIT_PREFIX_CHILDREN}-${POINT_OF_SALE}`;
export const EDIT_BANK_ACCOUNT: string = `${EDIT_PREFIX_CHILDREN}-${BANK_ACCOUNT}`;
export const EDIT_COMMISSION_BANK_ACCOUNT: string = `${EDIT_PREFIX_CHILDREN}-${COMMISSION_BANK_ACCOUNT}`;
export const EDIT_LOAN_APPLICATION_CONTINUE: string = `${EDIT_PREFIX_CHILDREN}-${EMAIL_CONTINUE_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_SEND_BANK: string = `${EDIT_PREFIX_CHILDREN}-${SEND_LOAN_APPLICATION_BANK}`;
export const EDIT_LOAN_APPLICATION_CLOSING_ADVISOR: string = `${EDIT_PREFIX_CHILDREN}-${CLOSING_ADVISOR_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_RECORDS: string = `${EDIT_PREFIX_CHILDREN}-${RECORDS_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_GIFT_CARDS: string = `${EDIT_PREFIX_CHILDREN}-${GIFT_CARDS_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_VALIDATION_ID: string = `${EDIT_PREFIX_CHILDREN}-${VALIDATION_ID_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_CREDITO_REAL: string = `${EDIT_PREFIX_CHILDREN}-${CREDITO_REAL_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_SALESFORCE: string = `${EDIT_PREFIX_CHILDREN}-${SALESFORCE_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_FINISH: string = `${EDIT_PREFIX_CHILDREN}-${FINISH_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_CLOSING_BANK: string = `${EDIT_PREFIX_CHILDREN}-${CLOSING_BANK_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_APPROVAL_CONDITIONS: string =
    `${EDIT_PREFIX_CHILDREN}-${APPROVAL_CONDITIONS_LOAN_APPLICATION}`;
export const EDIT_LOAN_APPLICATION_SEND_TO_PIPEFY: string = `${EDIT_PREFIX_CHILDREN}-${SEND_TO_PIPEFY_LOAN_APPLICATION}`;

export const PREVIEW_LOAN_APPLICATION: string = `${PREVIEW_PREFIX_CHILDREN}-${LOAN_APPLICATION}`;
export const PREVIEW_LOAN_APPLICATION_MOTORFY: string = `${PREVIEW_PREFIX_CHILDREN}-${LOAN_APPLICATION_MOTORFY}`;
export const PREVIEW_LOAN_APPLICATION_CC = `${PREVIEW_PREFIX_CHILDREN}-${LOAN_APPLICATION_CC}`;
export const PREVIEW_QUOTE: string = `${PREVIEW_PREFIX_CHILDREN}-${QUOTE}`;
export const PREVIEW_INSURANCE: string = `${PREVIEW_PREFIX_CHILDREN}-${INSURANCE}`;
export const PREVIEW_GPS: string = `${PREVIEW_PREFIX_CHILDREN}-${GPS}`;
export const PREVIEW_BANK_ACCOUNT: string = `${PREVIEW_PREFIX_CHILDREN}-${BANK_ACCOUNT}`;
export const PREVIEW_PRE_AUTHORIZATION: string = `${PREVIEW_PREFIX_CHILDREN}-${PRE_AUTHORIZATION}`;
export const PREVIEW_OPENING_COMMISSION: string = `${PREVIEW_PREFIX_CHILDREN}-${OPENING_COMMISSION}`;
export const PREVIEW_DEPOSIT_LETTER: string = `${PREVIEW_PREFIX_CHILDREN}-${DEPOSIT_LETTER}`;

export const CHECK_BUREAU: string = `${CHECK_PREFIX_CHILDREN}-${BUREAU}`;

export const EDIT_VEHICLE_MENU = {
    id: `${EDIT_VEHICLE}`,
    icon: '/assets/images/admin/car-icon.svg',
    iconSelected: '/assets/images/admin/car-icon-selected.svg',
    label: 'Datos del vehículo',
    shortLabel: 'Vehículo',
    selected: true,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_INSURANCE_MENU = {
    id: `${EDIT_INSURANCE}`,
    icon: '/assets/images/admin/insurance-icon.svg',
    iconSelected: '/assets/images/admin/insurance-icon-selected.svg',
    label: 'Seguro',
    shortLabel: 'Seguro',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_MECHANICAL_GUARANTEE_MENU = {
    id: `${EDIT_GUARANTEE_MECHANICAL}`,
    icon: '/assets/images/admin/guarantee-mechanica-icon.svg',
    iconSelected: '/assets/images/admin/guarantee-mechanica-icon-selected.svg',
    label: 'Garantía mecánica',
    shortLabel: 'Garantía',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.DISABLED_MENU
};

export const EDIT_CREDIT_CONDITION_MENU = {
    id: `${EDIT_CREDIT_CONDITION}`,
    icon: '/assets/images/admin/credit-icon.svg',
    iconSelected: '/assets/images/admin/credit-icon-selected.svg',
    label: 'Condiciones del crédito',
    shortLabel: 'Crédito',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_APPLICANT_DATA_MENU = {
    id: `${EDIT_APPLICANT}`,
    icon: '/assets/images/admin/client-data-icon.svg',
    iconSelected: '/assets/images/admin/client-data-icon-selected.svg',
    label: 'Datos del solicitante',
    shortLabel: 'Solicitante',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_HOME_DATA_MENU = {
    id: `${EDIT_HOME}`,
    icon: '/assets/images/admin/address-icon.svg',
    iconSelected: '/assets/images/admin/address-icon-selected.svg',
    label: 'Domicilio actual',
    shortLabel: 'Domicilio',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_WORK_DATA_MENU = {
    id: `${EDIT_WORK}`,
    icon: '/assets/images/admin/work-icon.svg',
    iconSelected: '/assets/images/admin/work-icon-selected.svg',
    label: 'Información laboral',
    shortLabel: 'Inf. Laboral',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_CURRENT_WORK_DATA_MENU = {
    id: `${EDIT_CURRENT_WORK}`,
    icon: '/assets/images/admin/work-icon.svg',
    iconSelected: '/assets/images/admin/work-icon-selected.svg',
    label: 'Empleo Actual',
    shortLabel: 'Empl. Actual',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LAST_WORK_DATA_MENU = {
    id: `${EDIT_LAST_WORK}`,
    icon: '/assets/images/admin/work-icon.svg',
    iconSelected: '/assets/images/admin/work-icon-selected.svg',
    label: 'Empleo Anterior',
    shortLabel: 'Empl. Anterior',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_REFERENCES_DATA_MENU = {
    id: `${EDIT_REFERENCE}`,
    icon: '/assets/images/admin/reference-icon.svg',
    iconSelected: '/assets/images/admin/reference-icon-selected.svg',
    label: 'Referencias',
    shortLabel: 'Referencias',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_PERSONAL_INTERVIEW_MENU = {
    id: `${EDIT_PERSONAL_INTERVIEW}`,
    icon: '/assets/images/admin/personal-interview-icon.svg',
    iconSelected: '/assets/images/admin/personal-interview-icon-selected.svg',
    label: 'Entrevista personal',
    shortLabel: 'Entrevista',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_BUREAU_DATA_MENU = {
    id: `${EDIT_BUREAU}`,
    icon: '/assets/images/admin/history-normal-icon.svg',
    iconSelected: '/assets/images/admin/history-normal-icon-selected.svg',
    label: 'Historial de Crédito',
    shortLabel: 'Historial',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_GPS_DATA_MENU = {
    id: `${EDIT_GPS}`,
    icon: '/assets/images/admin/gps-icon.svg',
    iconSelected: '/assets/images/admin/gps-icon-selected.svg',
    label: 'Instalación GPS',
    shortLabel: 'GPS',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: [
        ...RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR,
        RolesConstants.SUPERVISOR
    ]
};

export const EDIT_POINT_OF_SALE_DATA_MENU = {
    id: `${EDIT_POINT_OF_SALE}`,
    icon: '/assets/images/admin/point-of-sale-icon.svg',
    iconSelected: '/assets/images/admin/point-of-sale-icon-selected.svg',
    label: 'Agencia/Lote',
    shortLabel: 'Agencia/Lote',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_CHECK_BUREAU_DATA_MENU = {
    id: `${CHECK_BUREAU}`,
    icon: '/assets/images/admin/check-item.svg',
    iconSelected: '/assets/images/admin/check-item-selected.svg',
    label: 'Buró',
    shortLabel: 'Buró',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_BANK_ACCOUNT_DATA_MENU = {
    id: `${EDIT_BANK_ACCOUNT}`,
    icon: '/assets/images/admin/bank-account-icon.svg',
    iconSelected: '/assets/images/admin/bank-account-icon-selected.svg',
    label: 'Información de Fondeo',
    shortLabel: 'Inf. Fondeo',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: [
        RolesConstants.BANK_ACCOUNT_ADMIN_ROLE
    ]
};

export const EDIT_COMMISION_BANK_ACCOUNT_DATA_MENU = {
    id: `${EDIT_COMMISSION_BANK_ACCOUNT}`,
    icon: '/assets/images/admin/commission-bank-account-icon.svg',
    iconSelected: '/assets/images/admin/commission-bank-account-icon-selected.svg',
    label: 'Comisiones',
    shortLabel: 'Comisiones',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: [
        RolesConstants.BANK_ACCOUNT_ADMIN_ROLE,
        RolesConstants.SUPERVISOR
    ]
};

export const EDIT_EMAIL_LOAN_APPLICATION_MENU = {
    id: `${EDIT_LOAN_APPLICATION_CONTINUE}`,
    icon: '/assets/images/common/send-remainder-email.svg',
    iconSelected: '/assets/images/common/send-remainder-email-selected.svg',
    label: 'Mail continuar solicitud',
    shortLabel: 'Cont. solicitud',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_SEND_BANK_MENU = {
    id: `${EDIT_LOAN_APPLICATION_SEND_BANK}`,
    icon: '/assets/images/common/send-to-cr.svg',
    iconSelected: '/assets/images/common/send-to-cr-selected.svg',
    label: 'Enviar a Crédito Real',
    shortLabel: 'Enviar a CR',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_CLOSING_ADVISOR_MENU = {
    id: `${EDIT_LOAN_APPLICATION_CLOSING_ADVISOR}`,
    icon: '/assets/images/common/closing-advisor.svg',
    iconSelected: '/assets/images/common/closing-advisor-selected.svg',
    label: 'Asesor/Entidad',
    shortLabel: 'Asesor/Entidad',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: [
        RolesConstants.IMPLANT_ROLE,
        RolesConstants.SUPERVISOR
    ]
};

export const EDIT_LOAN_APPLICATION_RECORDS_MENU = {
    id: `${EDIT_LOAN_APPLICATION_RECORDS}`,
    icon: '/assets/images/admin/records-icon.svg',
    iconSelected: '/assets/images/admin/records-icon-selected.svg',
    label: 'Expediente físico',
    shortLabel: 'Expediente',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: [
        ...RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR,
        RolesConstants.SUPERVISOR
    ]
};

export const EDIT_LOAN_APPLICATION_GIFT_CARDS_MENU = {
    id: `${EDIT_LOAN_APPLICATION_GIFT_CARDS}`,
    icon: '/assets/images/admin/gift-card-icon.svg',
    iconSelected: '/assets/images/admin/gift-card-icon-selected.svg',
    label: 'Monedero',
    shortLabel: 'Monedero',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_VALIDATION_ID_MENU = {
    id: `${EDIT_LOAN_APPLICATION_VALIDATION_ID}`,
    icon: '/assets/images/admin/client-data-icon.svg',
    iconSelected: '/assets/images/admin/client-data-icon-selected.svg',
    label: 'Validación ID',
    shortLabel: 'Validación ID',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_CREDITO_REAL_MENU = {
    id: `${EDIT_LOAN_APPLICATION_CREDITO_REAL}`,
    icon: '/assets/images/common/send-to-cr.svg',
    iconSelected: '/assets/images/common/send-to-cr-selected.svg',
    label: 'Enviar a CR',
    shortLabel: 'Enviar a CR',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_SALESFORCE_MENU = {
    id: `${EDIT_LOAN_APPLICATION_SALESFORCE}`,
    icon: '/assets/images/admin/credit-icon.svg',
    iconSelected: '/assets/images/admin/credit-icon-selected.svg',
    label: 'Salesforce',
    shortLabel: 'Salesforce',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_FINISH_MENU = {
    id: `${EDIT_LOAN_APPLICATION_FINISH}`,
    icon: '/assets/images/admin/finish-icon.svg',
    iconSelected: '/assets/images/admin/finish-icon-selected.svg',
    label: 'Finalizar/Perdida',
    shortLabel: 'Finalizar/Perdida',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_CLOSING_BANK_MENU = {
    id: `${EDIT_LOAN_APPLICATION_CLOSING_BANK}`,
    icon: '/assets/images/admin/credit-icon.svg',
    iconSelected: '/assets/images/admin/credit-icon-selected.svg',
    label: 'Banco de cierre',
    shortLabel: 'Banco Cierre',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_APPROVAL_CONDITIONS_MENU = {
    id: `${EDIT_LOAN_APPLICATION_APPROVAL_CONDITIONS}`,
    // TODO: icon reused from Banco de cierre until Edu proposes a definitive icon for this section (see NRS-1444)
    icon: '/assets/images/admin/credit-icon.svg',
    iconSelected: '/assets/images/admin/credit-icon-selected.svg',
    label: 'Condiciones de aprobación',
    shortLabel: 'Condiciones',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const EDIT_LOAN_APPLICATION_SEND_TO_PIPEFY_MENU = {
    id: `${EDIT_LOAN_APPLICATION_SEND_TO_PIPEFY}`,
    icon: '/assets/images/admin/pipefy-icon.svg',
    iconSelected: '/assets/images/admin/pipefy-icon-selected.svg',
    label: 'Enviar a Pipefy',
    shortLabel: 'Pipefy',
    selected: false,
    hasError: false,
    labelError: '',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const PREVIEW_LOAN_APPLICATION_MENU = {
    id: `${PREVIEW_LOAN_APPLICATION}`,
    icon: '/assets/images/admin/application-icon.svg',
    iconSelected: '/assets/images/admin/application-icon-selected.svg',
    label: 'Solicitud',
    shortLabel: 'Solicitud',
    selected: false,
    hasError: false,
    labelError: 'Ingresa datos para la solicitud de crédito',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const PREVIEW_LOAN_APPLICATION_CC_MENU = {
    id: `${PREVIEW_LOAN_APPLICATION_CC}`,
    icon: '/assets/images/admin/application-icon.svg',
    iconSelected: '/assets/images/admin/application-icon-selected.svg',
    label: 'Reporte Historial Crediticio',
    shortLabel: 'REPORTE CC',
    selected: false,
    hasError: false,
    labelError: 'Esta solicitud no contiene Historial Crediticio',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const PREVIEW_LOAN_APPLICATION_MOTORFY_MENU = {
    id: `${PREVIEW_LOAN_APPLICATION_MOTORFY}`,
    icon: '/assets/images/admin/application-motorfy-icon.svg',
    iconSelected: '/assets/images/admin/application-motorfy-icon-selected.svg',
    label: 'Solicitud Motorfy',
    shortLabel: 'Sol. Motorfy',
    selected: false,
    hasError: false,
    labelError: 'Ingresa datos para la solicitud Mororfy',
    allowedRoles: RolesConstants.GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR
};

export const ATTACHMENT_MAIN_MENU = {
    id: ATTACHMENT,
    icon: '/assets/images/admin/attach-icon.svg',
    iconSelected: '/assets/images/admin/attach-icon-selected.svg',
    label: 'ADJUNTOS',
    hovered: false,
    selected: false,
    read: false,
    items: []
};

export const SUB_MENU_FILES_ATTACHMENTS: SimpleMenu[] = [
    {
        id: 'ApprovalDocument',
        label: 'Aprobaciones',
        hovered: false,
        selected: true,
    },
    {
        id: 'ContractDocument',
        label: 'Contratos',
        hovered: false,
        selected: false,
    },
    {
        id: 'OtherDocument',
        label: 'Otros',
        hovered: false,
        selected: false,
    }
];
